import Latex from "react-latex-next";
import { TbInfoCircle } from "react-icons/tb";
import { ZoomImage } from "../ZoomImage/ZoomImage";
import { EmqPartStepper } from "../EmqPartStepper/EmqPartStepper";
import {
  EmqGroupReviewRow,
  partOrderToLetter,
} from "../../utils/buildEmqGroupReview";
import { EmqPartStepStatus } from "../EmqPartStepper/EmqPartStepper";
import "./EmqGroupReviewPanel.scss";

type EmqGroupReviewPanelProps = {
  rows: EmqGroupReviewRow[];
  selectedQuestionId: number | null;
  onSelectPart: (questionId: number) => void;
  delimeters: any[];
};

function reviewPartStatuses(rows: EmqGroupReviewRow[]): EmqPartStepStatus[] {
  return rows.map((row) => {
    if (row.skipped) return "skipped";
    if (row.isCorrect) return "answered";
    return "incorrect";
  });
}

export function EmqGroupReviewPanel({
  rows,
  selectedQuestionId,
  onSelectPart,
  delimeters,
}: EmqGroupReviewPanelProps) {
  const selectedRow =
    rows.find((row) => row.questionId === selectedQuestionId) ?? null;
  const selectedPartOrder = selectedRow?.partOrder ?? rows[0]?.partOrder ?? 1;
  const partsCount = rows.length;

  const explanationLines = selectedRow?.explanation
    ?.split("\\n")
    .map((line, index) => (
      <p key={index} className="explanation-line">
        <Latex delimiters={delimeters}>{line}</Latex>
      </p>
    ));

  return (
    <div className="emq-group-review">
      <div className="emq-group-review__header">
        <div className="emq-group-review__heading">
          <h3 className="emq-group-review__title">EMQ results</h3>
          <span className="emq-group-review__info">
            <button
              type="button"
              className="emq-group-review__info-trigger"
              aria-describedby="emq-group-review-hint"
            >
              <TbInfoCircle aria-hidden="true" />
            </button>
            <span
              id="emq-group-review-hint"
              className="emq-group-review__info-tooltip"
              role="tooltip"
            >
              Select a part to read its explanation
            </span>
          </span>
        </div>

        <div className="emq-group-review__stepper">
          <EmqPartStepper
            partOrder={selectedPartOrder}
            partsCount={partsCount}
            partStatuses={reviewPartStatuses(rows)}
            onPartClick={(partOrder) => {
              const row = rows.find((r) => r.partOrder === partOrder);
              if (row) onSelectPart(row.questionId);
            }}
          />
        </div>
      </div>

      {selectedRow ? (
        <div className="emq-group-review__explanation">
          <div className="emq-group-review__explanation-label">
            Explanation · Part {partOrderToLetter(selectedRow.partOrder)}
          </div>
          <div className="explanation-box">{explanationLines}</div>
          {selectedRow.explanationImageUrl ? (
            <div className="emq-group-review__explanation-image">
              <ZoomImage src={selectedRow.explanationImageUrl} width={150} />
            </div>
          ) : null}
        </div>
      ) : null}
    </div>
  );
}
